import {createSelector} from '@ngrx/store';
import {CourseContent, CourseLecture} from '../../services/course-data.service';
import {State as AppState} from '../../state';
// import {pipe} from 'rxjs';
// import {map} from 'rxjs/operators';

export const selectAllArticles = createSelector(
	(state: AppState) => state.course.courses,
	(courses) => {
		return courses.map(c => {
			const newCrs = { ...c };
			return newCrs;
		})
			.sort((a, b) => new Date(b.publication_date).getTime() - new Date(a.publication_date).getTime());
	}
);

const preferredOrder = ['politics', 'history', 'literature', 'philosophy___religion', 'economics'];

export const selectAllCourses = createSelector(
	(state: AppState) => state.course.courses,
	(courses) => {
		return courses.map(c => {
			const newCrs = { ...c };
			return newCrs;
		})
			//Always sort courses by publish date (desc)
			.sort((a, b) => new Date(b.publication_date).getTime() - new Date(a.publication_date).getTime());
	}
);

export const selectAllCoursesForNav = createSelector(
	(state: AppState) => state.course.courses,
	(courses) => {
		return courses.map(c => {
			const newCrs = {
				title: c.title,
				url_slug: c.url_slug,
				publication_date: c.publication_date
			};
			return newCrs;
		})
			.sort((a, b) => new Date(a.publication_date).getTime() - new Date(b.publication_date).getTime());
	}
);

export function getCurrentCourse(courseState) {
	return courseState.courseDetails[courseState.currentCourse] || courseState.courses.find(c => c.url_slug === courseState.currentCourse);
}

export function getCurrentLesson(coursesState) {
	const course = getCurrentCourse(coursesState);
	return course && course.lectures.find(c => c.url_slug === coursesState.currentLesson) as CourseLecture;
}

export function getCurrentCourseContentByCourse(course, coursesState) {
	return course && coursesState.currentContentItem && course.lectures
		.filter(c => c)
		.find(c => c.system_id === coursesState.currentContentItem.system_id) as CourseContent;
}

export function getCurrentCourseContent(coursesState) {
	const course = getCurrentCourse(coursesState);
	return getCurrentCourseContentByCourse(course, coursesState);
}

export const selectCurrentCourse = createSelector(
	(state: AppState) => state.course,
	(state) => {
		return getCurrentCourse(state);
	}
);

export const selectCurrentLesson = createSelector(
	(state: AppState) => state.course,
	(state) => {
		return getCurrentLesson(state);
	}
);

export const selectCourseSlugsToCodeName = createSelector(
	(state: AppState) => state.course,
	course => course.courses.map(c => ({ slug: c.url_slug, codename: c.system_codename }))
);

export const selectCurrentLessonId = createSelector(
	(state: AppState) => state.course,
	(state) => state.currentLesson
);

export const selectCurrentStateSystemIds = createSelector(
	(state: AppState) => state.course,
	(state) => ({
		courseId: (getCurrentCourse(state) || { system_id: null }).system_id,
		lessonId: (getCurrentLesson(state) || { system_id: null }).system_id,
		contentId: (getCurrentCourseContent(state) || { system_id: null }).system_id
	})
);

export const selectCurrentDonationURL = createSelector(
	(state: AppState) => state.course,
	state => {
		const crs = getCurrentCourse(state);
		return (crs && crs.donation_url) || 'https://secured.hillsdale.edu/hillsdale/support-hillsdale-college?utm_campaign=online_symposium&sc=MK420UN2'
	}
)

export const getVideoLoc = () =>
	createSelector(
		(state, props) => state.course.videoProgress[props.videoId],
		(progress, props) => progress
	);
